up.compiler(".up_recontact", function (element) {
  const anim = element.querySelector("input#recontacting_animator");
  const slug = up.fragment.source(element).split("/").slice(-1)[0];
  anim.value = slug;
});
